module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image25.e97e8397.jpg";